import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    display: grid;
  }
  .banner-home {
    margin: 55px 0px;
  }
  form {
    input {
      color: #a3a3a3;
      font-weight: bold;
      width: calc(100% - 200px);
      height: 60px;
      padding-left: 25px;
      border: 0;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
    button {
      background: #efefef;
      color: #002666;
      font-weight: bold;
      width: 200px;
      height: 60px;
      border: 0;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }
`;

export const UpperSection = styled.div`
    margin: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;

    h1 {
        color: #002666;
        font-size: 32px;
    }

    span {
        color: #a3a3a3;
    }

    a {
        color: #002666;
        text-decoration: underline;
    }
`;

export const MiddleBanners = styled.div`
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    img {
        border-radius: 5px;
        height: 320px;
        width: auto;

    }
`;

export const Categories = styled.div`
    display: flex;
    justify-content: space-between;
    width: 80%;
`;

export const Caixa = styled.div`
  background: #002666;
  color: #fff;
  padding: 0;
  flex: 1;
  margin-bottom: 40px;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`;

export const SearchBarra = styled.div`
  background: #002666;
  color: #fff;
  padding: 0;
  justify-content: space-between;
  margin-top: 10px;
`;
export const Categorio = styled.div`
  justify-content: center;
  align-content: center;
  justify-content:  space-between;
  display: flex;
  margin-top: 20px;
`;

export const ColunCategorio = styled.div`
  width: 100%;

  @media (max-width: 768px) {
    width: 140px;
  }
`;
export const MoreAnunc = styled.div`
display: 'flex';

  @media (max-width: 768px) {
    display: none;
  }

`

export const Card = styled.div`
  color: #fff;
  display: flex;

  justify-content: space-between;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: row;
  }
  &:last-child{
    height: 115px;
  }
`;

export const Numero1 = styled.div`
  background-color: #fff;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2%;
  flex: 1;
  border-radius: 5px 0 0 5px;
`;

export const Numero2 = styled.div`
  background: #ffb615;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
    padding: 2%;
    border-radius:  0 5px 5px  0 ;
    button {
      height: 55px;
      padding:0;
      width: 165px;
      font-size: 20px;
      border-radius: 5px;
    }
`;

export const AllProducts = styled.div`
  width: 75%;

@media (max-width: 768px) {
  width: 63%;
  }
`

export const Products = styled.div`
  margin-top: 5%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;
